/* Chef Hassan's Kitchen: Event Planner. Turns a headcount and occasion into a ready-to-order
   spread. Dishes and prices come live from the catering collection, so nothing here goes stale. */
(function () {
  'use strict';
  var root = document.querySelector('[data-planner]');
  if (!root) return;
  var C = window.CHK || {};
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });
  var money = function (n) { return fmt.format(n); };

  /* ------------------------------------------------------------ the rules */
  var MIN_GUESTS = 10, MAX_GUESTS = 300;
  // Planning numbers from Hassan: a regular tray feeds about 15 people, a large tray about 25.
  var FEEDS = { regular: 15, large: 25 };
  var RANGE = { regular: [15, 15], large: [25, 25] };
  var FULL_SERVICE = 'full-catering-service-add-on';
  var OCCASIONS = [
    { id: 'corporate', label: 'Corporate', blurb: 'Office lunches, meetings, team events' },
    { id: 'private', label: 'Private party', blurb: 'Birthdays, showers, celebrations' },
    { id: 'gala', label: 'Wedding / gala', blurb: 'Plated-style spreads for big nights' }
  ];
  // The recommended dishes per occasion, by product handle. Edit here to change a spread.
  var SPREADS = {
    corporate: [['Main', 'jerk-chicken'], ['Main', 'beef-suya'], ['Rice', 'jollof-rice'], ['Side', 'greek-salad-1']],
    private: [['Starter', 'coconut-shrimp'], ['Main', 'jerk-chicken'], ['Main', 'curry-goat'], ['Rice', 'jollof-rice'], ['Side', 'plaintain-sliders'], ['Dessert', 'white-chocolate-brownies']],
    gala: [['Starter', 'charcuterie-platter'], ['Starter', 'coconut-shrimp'], ['Main', 'lamb-chops'], ['Main', 'grilled-salmon'], ['Rice', 'shrimp-fried-rice'], ['Side', 'mixed-vegetable'], ['Dessert', 'cheesecake-individually-sliced']]
  };
  var POOL_FOR_COURSE = { Starter: 'Starter', Side: 'Starter', Main: 'Main', Rice: 'Rice', Dessert: 'Dessert' };
  var POOL_LABELS = { Starter: 'Starters, sides & salads', Main: 'Mains', Rice: 'Rice & pasta', Dessert: 'Desserts' };
  var COURSE_FOR_POOL = { Starter: 'Side', Main: 'Main', Rice: 'Rice', Dessert: 'Dessert' };
  var COURSE_LABELS = { Starter: 'Starter', Main: 'Main', Rice: 'Rice & pasta', Side: 'Side', Dessert: 'Dessert', Service: 'Service' };
  var APPETITE = { Starter: { total: 1.4, cap: 0.7 }, Main: { total: 1.2, cap: 1 }, Rice: { total: 1.2, cap: 1 }, Side: { total: 1.2, cap: 1 }, Dessert: { total: 1, cap: 0.7 } };

  function poolForTags(tags) {
    var t = tags.map(function (x) { return x.toLowerCase(); });
    var has = function (list) { return t.some(function (x) { return list.indexOf(x) > -1; }); };
    if (has(['proteins', 'proteins & entrées', 'main'])) return 'Main';
    if (has(['rice', 'ravioli', 'pasta', 'specialty pasta'])) return 'Rice';
    if (has(['desserts', 'dessert'])) return 'Dessert';
    if (has(['starters', 'salads', 'salad', 'sides'])) return 'Starter';
    return null;
  }

  function share(course, guests, inCourse) {
    if (course === 'Service') return 0;
    var a = APPETITE[course];
    return Math.ceil(guests * Math.min(a.cap, a.total / Math.max(1, inCourse)));
  }
  // Large trays first; one regular tray covers a small remainder.
  function traysFor(people) {
    var large = Math.floor(people / FEEDS.large), rem = people - large * FEEDS.large, regular = 0;
    if (rem > FEEDS.regular) large += 1; else if (rem > 0) regular = 1;
    return { large: large, regular: regular };
  }
  function resize(lines, guests) {
    return lines.map(function (l) {
      if (l.manual || l.course === 'Service') return l;
      var n = lines.filter(function (x) { return x.course === l.course; }).length;
      var t = traysFor(share(l.course, guests, n));
      return { course: l.course, handle: l.handle, large: t.large, regular: t.regular, manual: l.manual };
    });
  }
  function recommend(occasion, guests) {
    return resize(SPREADS[occasion].map(function (d) { return { course: d[0], handle: d[1], large: 0, regular: 0 }; }), guests);
  }
  var lineFeeds = function (l) { return l.large * FEEDS.large + l.regular * FEEDS.regular; };
  // What a line feeds, said as a range because a tray's portions vary.
  function feedsText(l) {
    var lo = l.large * RANGE.large[0] + l.regular * RANGE.regular[0], hi = l.large * RANGE.large[1] + l.regular * RANGE.regular[1];
    if (!hi) return 'feeds none yet';
    return lo === hi ? 'feeds about ' + lo : 'feeds ' + lo + ' to ' + hi;
  }
  var linePrice = function (l, d) { return d ? l.large * (d.large ? d.large.price : 0) + l.regular * (d.regular ? d.regular.price : 0) : 0; };

  /* ----------------------------------------------------------------- state */
  var dishes = [], byHandle = {}, pools = { Starter: [], Main: [], Rice: [], Dessert: [] };
  var guests = 50, occasion = root.dataset.occasion || 'corporate', service = 'drop';
  var lines = [], edited = false, printKey = 0, shownSubtotal = null, focusId = null;

  var els = {
    guestsOut: $('[data-guests-out]'), range: $('[data-guests-range]'), ticket: $('[data-ticket]'),
    add: $('[data-add-spread]'), addError: $('[data-add-error]'), quoteBtn: $('[data-quote-toggle]'), quote: $('[data-quote]')
  };

  function tray(p, size) {
    var v = p.variants.filter(function (x) { return x.available && [x.option1, x.option2, x.option3].some(function (o) { return o && o.indexOf(size) === 0; }); })[0];
    return v ? { variantId: v.id, price: Number(v.price) } : null;
  }
  var isPlaceholder = function (u) { return /ck_logo_compressed|chefhassanlogo/.test(u); };
  var thumb = function (u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96'; };
  var fromPrice = function (d) { return money(Math.min.apply(null, [d.regular && d.regular.price, d.large && d.large.price].filter(Boolean))); };

  function load() {
    var col = root.dataset.collection || 'catering';
    return Promise.all([
      fetch(C.root + 'collections/' + col + '/products.json?limit=250').then(function (r) { return r.json(); }),
      fetch(C.root + 'products/' + FULL_SERVICE + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
    ]).then(function (res) {
      dishes = (res[0].products || []).map(function (p) {
        var img = p.images && p.images[0] ? p.images[0].src : '';
        return { handle: p.handle, title: p.title, image: img && !isPlaceholder(img) ? img : null, pool: poolForTags(p.tags || (p.tags = [])), regular: tray(p, 'Regular'), large: tray(p, 'Large') };
      }).filter(function (d) { return d.pool && ((d.regular && d.regular.price) || (d.large && d.large.price)); });
      var s = res[1], sv = s && s.variants.filter(function (v) { return v.available; })[0];
      if (s && sv) dishes.push({ handle: s.handle, title: s.title, image: null, pool: null, regular: null, large: { variantId: sv.id, price: sv.price / 100 } });
      dishes.forEach(function (d) { byHandle[d.handle] = d; if (d.pool) pools[d.pool].push(d); });
      Object.keys(pools).forEach(function (k) { pools[k].sort(function (a, b) { return a.title.localeCompare(b.title); }); });
    });
  }

  /* ---------------------------------------------------------------- render */
  function allLines() {
    var shown = lines.filter(function (l) { return byHandle[l.handle]; });
    return service === 'full' && byHandle[FULL_SERVICE] ? shown.concat([{ course: 'Service', handle: FULL_SERVICE, large: 1, regular: 0 }]) : shown;
  }

  function render() {
    var all = allLines();
    var shown = all.filter(function (l) { return l.course !== 'Service'; });
    var subtotal = all.reduce(function (s, l) { return s + linePrice(l, byHandle[l.handle]); }, 0);
    var covered = shown.filter(function (l) { return l.course === 'Main'; }).reduce(function (s, l) { return s + lineFeeds(l); }, 0);
    var isCovered = covered >= guests;
    var onTicket = {};
    lines.forEach(function (l) { onTicket[l.handle] = true; });
    var occ = OCCASIONS.filter(function (o) { return o.id === occasion; })[0];

    var rows = all.map(function (l, i) {
      var d = byHandle[l.handle];
      var isService = l.course === 'Service';
      var pool = isService ? null : POOL_FOR_COURSE[l.course];
      var tools = '';
      if (pool) {
        var opts = pools[pool].filter(function (x) { return x.handle === l.handle || !onTicket[x.handle]; })
          .map(function (x) { return '<option value="' + esc(x.handle) + '"' + (x.handle === l.handle ? ' selected' : '') + '>' + esc(x.title) + ' · from ' + fromPrice(x) + '</option>'; }).join('');
        tools = '<span class="EventPlanner-lineTools"><label class="EventPlanner-swap"><span aria-hidden="true">Swap ⇄</span>' +
          '<select data-swap="' + i + '" aria-label="Swap ' + esc(d.title) + ' for another ' + POOL_LABELS[pool].toLowerCase() + ' dish">' + opts + '</select></label>' +
          '<button type="button" class="EventPlanner-removeLine" data-remove="' + i + '" aria-label="Remove ' + esc(d.title) + '">Remove</button></span>';
      }
      var trays = '';
      if (!isService) {
        trays = '<span class="EventPlanner-trays">' + ['large', 'regular'].map(function (size) {
          return d[size] ? '<span class="EventPlanner-tray"><button type="button" data-adj="' + i + ':' + size + ':-1" data-fid="adj-' + i + size + 'm" aria-label="One fewer ' + size + ' tray of ' + esc(d.title) + '">−</button>' +
            '<span>' + l[size] + ' ' + (size === 'large' ? 'Lg' : 'Reg') + '</span>' +
            '<button type="button" data-adj="' + i + ':' + size + ':1" data-fid="adj-' + i + size + 'p" aria-label="One more ' + size + ' tray of ' + esc(d.title) + '">+</button></span>' : '';
        }).join('') + '</span>';
      }
      return '<li class="EventPlanner-line" style="animation-delay:' + (i * 55) + 'ms">' +
        '<span class="EventPlanner-thumb">' + (d.image ? '<img src="' + esc(thumb(d.image)) + '" alt="" width="44" height="44" loading="lazy" class="fill">' : '<span>CHK</span>') + '</span>' +
        '<span class="EventPlanner-lineInfo"><small>' + COURSE_LABELS[l.course] + (isService ? '' : ' · ' + feedsText(l)) + '</small><b>' + esc(d.title) + '</b>' + tools + '</span>' +
        trays + '<span class="EventPlanner-price">' + money(linePrice(l, d)) + '</span></li>';
    }).join('');

    var addOptions = Object.keys(pools).map(function (pool) {
      var list = pools[pool].filter(function (d) { return !onTicket[d.handle]; });
      return '<optgroup label="' + esc(POOL_LABELS[pool]) + '">' + list.map(function (d) { return '<option value="' + esc(d.handle) + '">' + esc(d.title) + ' · from ' + fromPrice(d) + '</option>'; }).join('') + '</optgroup>';
    }).join('');

    var compare = occasion === 'corporate' && guests >= 30
      ? '<p class="EventPlanner-compare">Feeding a team? Compare the <a href="' + C.root + 'products/office-lunch-catering-package">Office Lunch Package</a> at $30 per person.</p>' : '';

    els.ticket.innerHTML =
      '<div class="EventPlanner-stamp" data-on="' + isCovered + '" aria-hidden="true">Covered for ' + guests + '</div>' +
      '<div class="EventPlanner-ticketHead"><span>Event Planner · ' + esc(occ.label) + '</span></div>' +
      '<p class="EventPlanner-ticketTitle">Your spread for ' + guests + '</p>' +
      '<ul class="EventPlanner-lines" data-key="' + printKey + '">' + rows + '</ul>' +
      '<label class="EventPlanner-addDish"><span aria-hidden="true">+ Add a dish</span><select data-add aria-label="Add a dish to your spread"><option value="">Add a dish</option>' + addOptions + '</select></label>' +
      '<div class="EventPlanner-meter"><div class="EventPlanner-meterRow"><span>Mains feed about</span><span>' + covered + ' of ' + guests + ' guests</span></div>' +
      '<div class="EventPlanner-meterTrack"><div class="EventPlanner-meterFill" style="width:' + Math.min(100, covered / guests * 100) + '%" data-short="' + !isCovered + '"></div></div>' +
      (isCovered ? '' : '<p class="EventPlanner-warn">Add a main tray so everyone gets a full plate.</p>') + '</div>' +
      '<div class="EventPlanner-total" aria-live="polite"><span>Estimated subtotal*</span><b data-subtotal>' + money(shownSubtotal == null ? subtotal : shownSubtotal) + '</b></div>' +
      '<p class="EventPlanner-perPerson">About ' + money(subtotal / guests) + ' per guest*, before tax &amp; delivery.' +
      (edited ? ' <button type="button" class="EventPlanner-reset" data-reset>Reset to our recommendation</button>' : '') + '</p>' + compare;

    countUp(subtotal);
    if (els.add) els.add.disabled = !all.some(function (l) { return l.large + l.regular > 0; });
    if (focusId) { var f = $('[data-fid="' + focusId + '"]'); if (f) f.focus(); focusId = null; }
  }

  // The subtotal counts to its new value instead of jumping.
  var raf = 0;
  function countUp(value) {
    var out = $('[data-subtotal]');
    if (!out) return;
    var start = shownSubtotal == null ? value : shownSubtotal;
    cancelAnimationFrame(raf);
    if (start === value || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { shownSubtotal = value; out.textContent = money(value); return; }
    var t0 = performance.now();
    var step = function (now) {
      var p = Math.min(1, (now - t0) / 420);
      shownSubtotal = start + (value - start) * (1 - Math.pow(1 - p, 3));
      var o = $('[data-subtotal]'); if (o) o.textContent = money(shownSubtotal);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
  }

  /* ---------------------------------------------------------------- events */
  function setGuests(n) {
    guests = Math.max(MIN_GUESTS, Math.min(MAX_GUESTS, n));
    els.guestsOut.textContent = guests; els.range.value = guests;
    lines = resize(lines, guests); render();
  }
  function setOccasion(id) {
    occasion = id; lines = recommend(occasion, guests); edited = false; printKey++; render();
  }

  $('[data-guests-down]').addEventListener('click', function () { setGuests(guests - 5); });
  $('[data-guests-up]').addEventListener('click', function () { setGuests(guests + 5); });
  els.range.addEventListener('input', function () { setGuests(Number(els.range.value)); });
  $$('input[name=planner-occasion]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) setOccasion(r.value); }); });
  $$('input[name=planner-service]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) { service = r.value; render(); } }); });

  els.ticket.addEventListener('click', function (e) {
    var a = e.target.closest('[data-adj]');
    if (a) {
      var p = a.dataset.adj.split(':'), i = Number(p[0]);
      lines = lines.map(function (l, n) { if (n !== i) return l; var c = { course: l.course, handle: l.handle, large: l.large, regular: l.regular, manual: true }; c[p[1]] = Math.max(0, l[p[1]] + Number(p[2])); return c; });
      edited = true; focusId = a.dataset.fid; render(); return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) { lines = resize(lines.filter(function (_, n) { return n !== Number(rm.dataset.remove); }), guests); edited = true; render(); return; }
    if (e.target.closest('[data-reset]')) { lines = recommend(occasion, guests); edited = false; printKey++; render(); }
  });
  els.ticket.addEventListener('change', function (e) {
    var sw = e.target.closest('[data-swap]');
    if (sw) {
      var i = Number(sw.dataset.swap);
      lines = resize(lines.map(function (l, n) { return n === i ? { course: l.course, handle: sw.value, large: l.large, regular: l.regular, manual: l.manual } : l; }), guests);
      edited = true; render(); return;
    }
    var ad = e.target.closest('[data-add]');
    if (ad && ad.value) {
      var d = byHandle[ad.value];
      if (!d || !d.pool) return;
      lines = resize(lines.concat([{ course: COURSE_FOR_POOL[d.pool], handle: d.handle, large: 0, regular: 0 }]), guests);
      edited = true; render();
    }
  });

  var clamp = function (n) { return Math.max(0, Math.min(50, Math.floor(Number(n) || 0))); };
  var occLabel = function () { return OCCASIONS.filter(function (o) { return o.id === occasion; })[0].label; };

  if (els.add) els.add.addEventListener('click', function () {
    var items = [];
    allLines().forEach(function (l) {
      var d = byHandle[l.handle];
      if (!d) return;
      if (d.large && clamp(l.large)) items.push({ id: d.large.variantId, quantity: clamp(l.large) });
      if (d.regular && clamp(l.regular)) items.push({ id: d.regular.variantId, quantity: clamp(l.regular) });
    });
    els.addError.textContent = '';
    if (!items.length) { els.addError.textContent = 'Add at least one tray to your ticket first.'; return; }
    var label = els.add.textContent; els.add.disabled = true; els.add.textContent = 'Adding…';
    // The ticket opens the moment they tap; the spread prints onto it as it's confirmed.
    window.CHKCart.open({ pending: 'Your Event Planner spread' });
    window.CHKCart.add(items, { Guests: String(guests), Occasion: occLabel(), 'Planned with': 'Event Planner' })
      .catch(function () { window.CHKCart.failed(); els.addError.textContent = "Couldn't add your spread. Please try again."; })
      .then(function () { els.add.textContent = label; els.add.disabled = false; });
  });

  if (els.quoteBtn) {
    els.quoteBtn.addEventListener('click', function () {
      var open = els.quote.hidden;
      els.quote.hidden = !open; els.quoteBtn.setAttribute('aria-expanded', String(open));
    });
    var form = $('form', els.quote);
    if (form) form.addEventListener('submit', function () {
      var all = allLines().filter(function (l) { return clamp(l.large) + clamp(l.regular) > 0; }), total = 0;
      var text = all.map(function (l) {
        var d = byHandle[l.handle], cost = linePrice(l, d); total += cost;
        var t = [clamp(l.large) && clamp(l.large) + ' large', clamp(l.regular) && clamp(l.regular) + ' regular'].filter(Boolean).join(' + ');
        return l.course + ': ' + (d ? d.title : l.handle) + ', ' + t + ' ($' + cost.toFixed(2) + ')';
      }).join('\n');
      form.elements['contact[Occasion]'].value = occLabel();
      form.elements['contact[Guests]'].value = String(guests);
      form.elements['contact[Service]'].value = service === 'full' ? 'Full service with staff' : 'Drop-off';
      form.elements['contact[body]'].value = 'Event Planner spread:\n' + text + '\n\nEstimated subtotal: $' + total.toFixed(2) + ' before tax & delivery';
    });
  }

  /* ------------------------------------------------------------------ boot */
  els.ticket.innerHTML = '<p class="EventPlanner-perPerson" role="status">Loading the menu…</p>';
  load().then(function () {
    lines = recommend(occasion, guests);
    render();
  }).catch(function () {
    els.ticket.innerHTML = '<p class="EventPlanner-warn" role="alert">The planner couldn\'t load the menu. Please refresh, or <a href="' + C.root + 'pages/contact">ask us for a quote</a>.</p>';
  });
})();
